import React from "react";
import {
  Button,
  Col,
  Row,
  Table,
  Input,
  Form,
  Icon,
  Select,
  DatePicker,
  Tooltip
} from "antd";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ReactJson from "react-json-view";
import BunkeyAPI from "../../../api/BunkeyAPI";
import moment from "moment";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { injectIntl } from "react-intl";
import { LIMIT_ROWS_EOS_REPORT, sendNotification } from "../../../utils";
import { handleFetchingSauronReport } from "../../../actions/ClientAction";
import ClientRegister from "./ClientRegister";
import { useJsonToCsv } from "react-json-csv";
import { setCpActivityLogSelectedValue } from "../../../actions/AppAction";

const { Option } = Select;

const { RangePicker } = DatePicker;
const dateFormat = "YYYY/MM/DD";

const { saveAsCsv } = useJsonToCsv();
const fields = {
  client: "Cliente",
  action: "Acción",
  name: "Usuario",
  email: "Email",
  updatedAt: "Fecha",
  isSuccess: "¿Exitosa?"
};

export class ActivityRegister extends React.Component {
  constructor(props) {
    super(props);

    const { intl, cpActivityLogSelectedValue } = this.props;

    this.logTypes = [
      {
        id: "ClientController.creat",
        value: intl.formatMessage({
          id: "eye_of_sauron_ClientController.creat"
        })
      },
      {
        id: "ClientController.deleteById",
        value: intl.formatMessage({
          id: "eye_of_sauron_ClientController.deleteById"
        })
      },
      {
        id: "ClientController.updateById",
        value: intl.formatMessage({
          id: "eye_of_sauron_ClientController.updateById"
        })
      },
      {
        id: "GroupController.create",
        value: intl.formatMessage({
          id: "eye_of_sauron_GroupController.create"
        })
      },
      {
        id: "GroupController.deleteById",
        value: intl.formatMessage({
          id: "eye_of_sauron_GroupController.deleteById"
        })
      },
      {
        id: "GroupController.updateById",
        value: intl.formatMessage({
          id: "eye_of_sauron_GroupController.updateById"
        })
      },
      {
        id: "InvitationController.create",
        value: intl.formatMessage({
          id: "eye_of_sauron_InvitationController.create"
        })
      },
      {
        id: "InvitationController.validate",
        value: intl.formatMessage({
          id: "eye_of_sauron_InvitationController.validate"
        })
      },
      {
        id: "ObjectController.confirm",
        value: intl.formatMessage({
          id: "eye_of_sauron_ObjectController.confirm"
        })
      },
      {
        id: "ObjectController.create",
        value: intl.formatMessage({
          id: "eye_of_sauron_ObjectController.create"
        })
      },
      {
        id: "ObjectController.deleteById",
        value: intl.formatMessage({
          id: "eye_of_sauron_ObjectController.deleteById"
        })
      },
      {
        id: "ObjectController.updateById",
        value: intl.formatMessage({
          id: "eye_of_sauron_ObjectController.updateById"
        })
      },
      {
        id: "SharedController.create",
        value: intl.formatMessage({
          id: "eye_of_sauron_SharedController.create"
        })
      },
      {
        id: "SharedController.createDownloadLink",
        value: intl.formatMessage({
          id: "eye_of_sauron_SharedController.createDownloadLink"
        })
      },
      {
        id: "SharedController.validate",
        value: intl.formatMessage({
          id: "eye_of_sauron_SharedController.validate"
        })
      },
      {
        id: "UserController.create",
        value: intl.formatMessage({ id: "eye_of_sauron_UserController.create" })
      },
      {
        id: "UserController.deleteById",
        value: intl.formatMessage({
          id: "eye_of_sauron_UserController.deleteById"
        })
      },
      {
        id: "UserController.updateById",
        value: intl.formatMessage({
          id: "eye_of_sauron_UserController.updateById"
        })
      },
      {
        id: "UserController.updateMe",
        value: intl.formatMessage({
          id: "eye_of_sauron_UserController.updateMe"
        })
      },
      {
        id: "ObjectController.getAssetById",
        value: intl.formatMessage({
          id: "eye_of_sauron_ObjectController.getAssetById"
        })
      },
      {
        id: "ObjectController.usersToComment",
        value: intl.formatMessage({
          id: "eye_of_sauron_ObjectController.usersToComment"
        })
      },
      {
        id: "recoveryPassword",
        value: intl.formatMessage({ id: "eye_of_sauron_recoveryPassword" })
      },
      {
        id: "signIn",
        value: intl.formatMessage({ id: "eye_of_sauron_signIn" })
      },
      {
        id: "userAccessClient",
        value: intl.formatMessage({ id: "eye_of_sauron_userAccessClient" })
      }
    ];

    this.columns = [
      {
        title: intl.formatMessage({ id: "clients_client" }),
        key: "client",
        render: ({ client }) => (client && client.name ? client.name : "")
      },
      {
        title: intl.formatMessage({ id: "action" }),
        key: "action",
        render: ({ action }) =>
          intl.formatMessage({ id: `eye_of_sauron_${action}` })
      },
      {
        title: intl.formatMessage({ id: "user" }),
        key: "name",
        dataIndex: "name"
      },
      {
        title: intl.formatMessage({ id: "email" }),
        key: "email",
        dataIndex: "email"
      },
      {
        title: intl.formatMessage({ id: "date_range" }),
        key: "createdAt",
        render: ({ createdAt }) =>
          `${moment(createdAt).format("DD-MM-YYYY HH:mm:ss")} Hrs`
      },
      {
        title: intl.formatMessage({ id: "successful_question" }),
        key: "isSuccess",
        render: ({ isSuccess }) =>
          isSuccess
            ? intl.formatMessage({ id: "yes" })
            : intl.formatMessage({ id: "no" })
      },
      {
        // KAN-44: versión de la app desde la que se hizo la acción, para poder
        // certificar en qué versión estaba el usuario al momento del hecho que
        // denuncia o reclama. Los registros anteriores al despliegue de la
        // 7.0.0 no la traen y se muestran con un guión.
        title: intl.formatMessage({ id: "app_version_column" }),
        key: "appVersion",
        render: ({ appVersion }) => (appVersion ? `v${appVersion}` : "—")
      }
    ];

    const limit = 10;
    this.state = {
      searchInClient: false,
      isFetching: true,
      autoRefresh: {
        pidFetch: null,
        pidTime: null,
        count: 0,
        percent: 0,
        on: false
      },
      filter: {
        clientType: "all",
        businessType: "all",
        client_name: "",
        user_email: "",
        user_name: "",
        action: cpActivityLogSelectedValue ? cpActivityLogSelectedValue : "all",
        dateRange: null,
        modules: {
          sistemasDeGrupos: false,
          commentsAndVersions: false,
          BunkeyHost: false,
          MFA: false
        }
      },
      page: 1,
      count: 0,
      limit: limit,
      orderBy: "createdAt",
      orderDir: "desc",
      clients: [],
      data: [],
      options: [],
      optionsUser: [],
      colorCreationdate: "",
      paginationColor: {
        10: limit === 10 ? "#eaeaea" : "",
        20: limit === 20 ? "#eaeaea" : "",
        40: limit === 40 ? "#eaeaea" : "",
        60: limit === 60 ? "#eaeaea" : "",
        80: limit === 80 ? "#eaeaea" : "",
        100: limit === 100 ? "#eaeaea" : ""
      },
      iconPaginationColor: {
        10: limit === 10,
        20: limit === 20,
        40: limit === 40,
        60: limit === 60,
        80: limit === 80,
        100: limit === 100
      }
    };
  }

  componentDidMount() {
    const { users } = this.props;
    this.props.setCpActivityLogSelectedValue(null);

    BunkeyAPI({
      url: `admin/clients?page=1&limit=9999`,
      method: "GET"
    })
      .then(resp => {
        if (resp.status === 200) {
          this.setState(
            {
              clients: resp.data.map(r => {
                return {
                  _id: r._id,
                  name: r.name,
                  modules: r.modules,
                  email: r.email
                };
              })
            },
            this.handleGetData
          );
        }
      })
      .catch(err => {
        console.log("mount err: ", err);
      });

    this.setState({
      options: users.map((r, k) => {
        return (
          <Option key={k} value={r.email} uid={r._id}>
            {r.email}
          </Option>
        );
      }),
      optionsUser: users.map((r, k) => {
        return (
          <Option key={k} value={r.name} uid={r._id}>
            {r.name}
          </Option>
        );
      })
    });
  }

  handleGetData = () => {
    const { filter, page, limit, orderBy, orderDir } = this.state;
    let query = [];
    let order = {
      field: [orderBy],
      type: orderDir,
      limit: limit,
      page: page
    };

    /*if (filter.clientType !== "all") {
      query = [
        ...query,
        {
          field: "client.type",
          type: "eq",
          value: filter.clientType
        }
      ];
    }

    if (filter.businessType !== "all") {
      query = [
        ...query,
        {
          field: "business.type",
          type: "eq",
          value: filter.businessType
        }
      ];
    }*/

    if (filter.client_name !== "") {
      query = [
        ...query,
        {
          field: "client.name",
          type: "regex",
          value: filter.client_name
        }
      ];
    }

    if (filter.user_email[0] !== undefined) {
      query = [
        ...query,
        {
          field: "email",
          type: "eq",
          value: filter.user_email[0]
        }
      ];
    }

    if (filter.user_name[0] !== undefined) {
      query = [
        ...query,
        {
          field: "name",
          type: "eq",
          value: filter.user_name[0]
        }
      ];
    }

    if (filter.action !== "all") {
      query = [
        ...query,
        {
          field: "action",
          type: "eq",
          value: filter.action
        }
      ];
    }

    /*let modules = [];
    for (const key in filter.modules) {
      if (filter.modules[key] === true) {
        modules.push(key);
      }
    }

    if (modules.length > 0) {
      const clientFilter = clients.filter(item => {
        if (item.modules.length > 0 && modules.every(r => item.modules.map(item => item.name).includes(r))) {
          return item;
        }
        return null;
      });

      query = [
        ...query,
        {
          field: "client.id",
          type: "in",
          value: clientFilter.map(item => item._id)
        }
      ];
    }*/

    if (Array.isArray(filter.dateRange)) {
      if (filter.dateRange[0]) {
        filter.dateRange[0].set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        });
        query = [
          ...query,
          {
            field: "fromDate",
            type: "eq",
            value: filter.dateRange[0]
          }
        ];
      }

      if (filter.dateRange[1]) {
        filter.dateRange[1].set({
          hour: 23,
          minute: 59,
          second: 59,
          millisecond: 999
        });
        query = [
          ...query,
          {
            field: "toDate",
            type: "eq",
            value: filter.dateRange[1]
          }
        ];
      }
    }

    if (query.length > 0) {
      BunkeyAPI({
        url: `/logs?q=${JSON.stringify(query)}&order=${JSON.stringify(order)}`,
        method: "GET"
      })
        .then(resp => {
          if (resp.status === 200) {
            this.setState({
              data: resp.data,
              limit: parseInt(resp.headers["x-pagination-limit"]),
              count: parseInt(resp.headers["x-pagination-total-count"]),
              isFetching: false,
              searchInClient: false
            });
          }
        })
        .catch(err => {
          console.log("error: ", err);
        });
    } else {
      BunkeyAPI({
        url: `/logs?order=${JSON.stringify(order)}`,
        method: "GET"
      })
        .then(resp => {
          if (resp.status === 200) {
            this.setState({
              data: resp.data,
              limit: parseInt(resp.headers["x-pagination-limit"]),
              count: parseInt(resp.headers["x-pagination-total-count"]),
              isFetching: false,
              searchInClient: false
            });
          }
        })
        .catch(err => {
          console.log("error: ", err);
        });
    }
  };

  handleOnClientTypeChange = value => {
    const { filter } = this.state;
    this.setState(
      {
        searchInClient: true,
        //isFetching: true,
        page: 1,
        filter: {
          ...filter,
          clientType: value
        }
      },
      this.handleGetData
    );
  };

  handleOnBusinessTypeChange = value => {
    const { filter } = this.state;
    this.setState(
      {
        searchInClient: true,
        //isFetching: true,
        page: 1,
        filter: {
          ...filter,
          businessType: value
        }
      },
      this.handleGetData
    );
  };

  handleOnActionChange = value => {
    const { filter } = this.state;
    this.setState(
      {
        isFetching: true,
        page: 1,
        filter: {
          ...filter,
          action: value
        }
      },
      this.handleGetData
    );
  };

  handleOnDateRangeChange = dates => {
    const { filter } = this.state;
    this.setState(
      {
        isFetching: true,
        page: 1,
        filter: {
          ...filter,
          dateRange: dates
        }
      },
      this.handleGetData
    );
  };

  handleOnInputChange = e => {
    const { filter } = this.state;
    this.setState(
      {
        isFetching: true,
        page: 1,
        filter: {
          ...filter,
          [e.target.name]: e.target.value
        }
      },
      this.handleGetData
    );
  };

  handleOnChangeEmail = value => {
    const { filter } = this.state;
    if (value.length >= 0) {
      this.setState(
        {
          isFetching: true,
          page: 1,
          filter: {
            ...filter,
            user_email: value
          }
        },
        this.handleGetData
      );
    }
  };

  handleOnChangeUserName = value => {
    const { filter } = this.state;
    if (value.length >= 0) {
      this.setState(
        {
          isFetching: true,
          page: 1,
          filter: {
            ...filter,
            user_name: value
          }
        },
        this.handleGetData
      );
    }
  };

  handleModuleFilter = moduleName => {
    const { filter } = this.state;
    filter.modules[moduleName] = !filter.modules[moduleName];
    this.setState(
      {
        searchInClient: true,
        isFetching: false,
        page: 1,
        filter: filter
      },
      this.handleGetData
    );
  };

  handleOrderBy = (orderBy, orderDir) => {
    this.setState(
      {
        orderBy,
        orderDir,
        isFetching: true,
        page: 1
      },
      this.handleGetData
    );
    if (orderBy === "createdAt" && orderDir === "asc")
      this.handleActive("createdAt");
    else if (orderBy === "createdAt" && orderDir === "desc")
      this.handleActive("-createdAt");
    else if (orderBy === "name" && orderDir === "asc")
      this.handleActive("name");
    else if (orderBy === "name" && orderDir === "desc")
      this.handleActive("-name");
  };

  handlePaginationNumber = limit => {
    this.setState(
      {
        isFetching: true,
        page: 1,
        limit: limit,
        paginationColor: { [limit]: "#eaeaea" },
        iconPaginationColor: {
          [limit]: true
        }
      },
      this.handleGetData
    );
  };

  handleOnPageChange = value => {
    this.setState(
      {
        isFetching: true,
        page: value
      },
      this.handleGetData
    );
  };

  handleActive = orderBy => {
    if (orderBy === "-createdAt") {
      this.setState({
        colorCreatedAt: "#eaeaea",
        colorCreationdate: "",
        colorAZ: "",
        colorZA: "",
        iconCreatedAt: true,
        iconCreationdate: false,
        iconAZ: false,
        iconZA: false
      });
    } else if (orderBy === "createdAt") {
      this.setState({
        colorCreatedAt: "",
        colorCreationdate: "#eaeaea",
        colorAZ: "",
        colorZA: "",
        iconCreatedAt: false,
        iconCreationdate: true,
        iconAZ: false,
        iconZA: false
      });
    } else if (orderBy === "name") {
      this.setState({
        colorCreatedAt: "",
        colorCreationdate: "",
        colorAZ: "#eaeaea",
        colorZA: "",
        iconCreatedAt: false,
        iconCreationdate: false,
        iconAZ: true,
        iconZA: false
      });
    } else if (orderBy === "-name") {
      this.setState({
        colorCreatedAt: "",
        colorCreationdate: "",
        colorAZ: "",
        colorZA: "#eaeaea",
        iconCreatedAt: false,
        iconCreationdate: false,
        iconAZ: false,
        iconZA: true
      });
    }
  };

  handleExportToFile = () => {
    const { filter, page, orderBy, orderDir } = this.state;
    const {
      intl,
      handleFetchingSauronReport,
      isFetchingSauronReport
    } = this.props;

    if (isFetchingSauronReport) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "eye_of_sauron_already_report" })
      );
    } else {
      let query = [];
      let order = {
        field: [orderBy],
        type: orderDir,
        limit: LIMIT_ROWS_EOS_REPORT,
        page: page
      };

      /*if (filter.clientType !== "all") {
        query = [
          ...query,
          {
            field: "client.type",
            type: "eq",
            value: filter.clientType
          }
        ];
      }

      if (filter.businessType !== "all") {
        query = [
          ...query,
          {
            field: "business.type",
            type: "eq",
            value: filter.businessType
          }
        ];
      }*/

      if (filter.client_name !== "") {
        query = [
          ...query,
          {
            field: "client.name",
            type: "regex",
            value: filter.client_name
          }
        ];
      }

      if (filter.user_email[0] !== undefined) {
        query = [
          ...query,
          {
            field: "email",
            type: "eq",
            value: filter.user_email[0]
          }
        ];
      }

      if (filter.user_name[0] !== undefined) {
        query = [
          ...query,
          {
            field: "name",
            type: "eq",
            value: filter.user_name[0]
          }
        ];
      }

      if (filter.action !== "all") {
        query = [
          ...query,
          {
            field: "action",
            type: "eq",
            value: filter.action
          }
        ];
      }

      /*let modules = [];
      for (const key in filter.modules) {
        if (filter.modules[key] === true) {
          modules.push(key);
        }
      }

      if (modules.length > 0) {
        const clientFilter = clients.filter(item => {
          if (item.modules.length > 0 && modules.every(r => item.modules.map(item => item.name).includes(r))) {
            return item;
          }
          return null;
        });

        query = [
          ...query,
          {
            field: "client.id",
            type: "in",
            value: clientFilter.map(item => item._id)
          }
        ];
      }*/

      if (Array.isArray(filter.dateRange)) {
        if (filter.dateRange[0]) {
          filter.dateRange[0].set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
          });
          query = [
            ...query,
            {
              field: "fromDate",
              type: "eq",
              value: filter.dateRange[0]
            }
          ];
        }

        if (filter.dateRange[1]) {
          filter.dateRange[1].set({
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 999
          });
          query = [
            ...query,
            {
              field: "toDate",
              type: "eq",
              value: filter.dateRange[1]
            }
          ];
        }
      }

      handleFetchingSauronReport(true);
      sendNotification(
        "info",
        intl,
        intl.formatMessage({ id: "eye_of_sauron_processing_report" })
      );

      BunkeyAPI({
        url:
          query.length > 0
            ? `/logs?q=${JSON.stringify(query)}&order=${JSON.stringify(order)}`
            : `/logs?order=${JSON.stringify(order)}`,
        method: "GET"
      })
        .then(resp => {
          handleFetchingSauronReport(false);
          const { data, status } = resp;
          if (status === 200) {
            saveAsCsv({
              data: data.map(d => {
                return {
                  ...d,
                  action: d.action
                    ? intl.formatMessage({ id: `eye_of_sauron_${d.action}` })
                    : "",
                  client: d.client && d.client.name ? d.client.name : "",
                  isSuccess: d.isSuccess ? "Si" : "No",
                  name: d.name ? d.name : "",
                  updatedAt: `${moment(d.createdAt).format(
                    "DD/MM/YYYY"
                  )}-${moment(d.createdAt).format("HH:mm:ss")} `
                };
              }),
              fields,
              filename: `Reporte-${moment()
                .utc()
                .local()
                .format("DD-MM-YYYY")} ${moment
                .tz("America/Santiago")
                .format("HH:mm:ss")}`
            });
          }
        })
        .catch(err => {
          console.log("error: ", err);
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "eye_of_sauron_report_error" })
          );
          handleFetchingSauronReport(false);
        });
    }
  };

  functionalServices = () =>
    this.props.planServices.filter(e => e.type === "3");

  render() {
    const {
      filter,
      data,
      options,
      optionsUser,
      count,
      limit,
      page,
      isFetching,
      colorCreationdate,
      colorCreatedAt,
      colorAZ,
      colorZA,
      iconCreationdate,
      iconCreatedAt,
      iconAZ,
      iconZA,
      iconPaginationColor
    } = this.state;

    const { intl, orderBy, newColor } = this.props;

    return (
      <div className="">
        <div className="title-bar">
          <div className="container" style={{ borderLeftColor: newColor }}>
            <span>{intl.formatMessage({ id: "activity_log" })}</span>
            <div
              style={{
                display: "block",
                float: "right",
                marginRight: 10,
                marginTop: 10
              }}
            ></div>
          </div>
        </div>
        <div className="container">
          <Row>
            <Col span={24}>
              <Form layout="vertical" onSubmit={this.handleSubmit}>
                <Row type="flex" justify="space-between" gutter={16}>
                  <Col>
                    <Form.Item
                      label={intl.formatMessage({ id: "type_clients" })}
                    >
                      <Select
                        defaultValue={filter.clientType}
                        value={filter.clientType}
                        onChange={this.handleOnClientTypeChange}
                      >
                        <Option value="all">
                          {intl.formatMessage({ id: "all" })}
                        </Option>
                        <Option value="free">
                          {intl.formatMessage({ id: "free" })}
                        </Option>
                        <Option value="professional">
                          {intl.formatMessage({ id: "professional" })}
                        </Option>
                        <Option value="small_business">
                          {intl.formatMessage({ id: "small_business" })}
                        </Option>
                        <Option value="enterprise">
                          {intl.formatMessage({ id: "enterprise" })}
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item
                      label={intl.formatMessage({ id: "type_business" })}
                    >
                      <Select
                        defaultValue={filter.businessType}
                        value={filter.businessType}
                        onChange={this.handleOnBusinessTypeChange}
                      >
                        <Option value="all">
                          {intl.formatMessage({ id: "all" })}
                        </Option>
                        <Option value="advertising">
                          {intl.formatMessage({ id: "advertising" })}
                        </Option>
                        <Option value="audiovisual">
                          {intl.formatMessage({ id: "audiovisual" })}
                        </Option>
                        <Option value="printing">
                          {intl.formatMessage({ id: "printing" })}
                        </Option>
                        <Option value="services_or_consulting">
                          {intl.formatMessage({ id: "services_or_consulting" })}
                        </Option>
                        <Option value="graphic_design">
                          {intl.formatMessage({ id: "graphic_design" })}
                        </Option>
                        <Option value="community_manager">
                          {intl.formatMessage({ id: "community_manager" })}
                        </Option>
                        <Option value="web">
                          {intl.formatMessage({ id: "web" })}
                        </Option>
                        <Option value="marketing">
                          {intl.formatMessage({ id: "marketing" })}
                        </Option>
                        <Option value="animations">
                          {intl.formatMessage({ id: "animations" })}
                        </Option>
                        <Option value="illustrations">
                          {intl.formatMessage({ id: "illustrations" })}
                        </Option>
                        <Option value="student">
                          {intl.formatMessage({ id: "student" })}
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item
                      label={intl.formatMessage({ id: "account_name" })}
                    >
                      <Input
                        prefix={
                          <Icon
                            type="search"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        name="client_name"
                        onChange={this.handleOnInputChange}
                        type="text"
                        placeholder={intl.formatMessage({
                          id: "advanced_search_search"
                        })}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={5}>
                    <Form.Item label={intl.formatMessage({ id: "action" })}>
                      <Select
                        showSearch={true}
                        defaultValue={filter.action}
                        value={filter.action}
                        onChange={this.handleOnActionChange}
                        style={{ width: "100%" }}
                      >
                        <Option key={"all"}>
                          {intl.formatMessage({ id: "all" })}
                        </Option>
                        {this.logTypes
                          .sort((a, b) => (a.value > b.value ? 1 : -1))
                          .map(r => (
                            <Option key={r.id}>{r.value}</Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item label={intl.formatMessage({ id: "date_range" })}>
                      <RangePicker
                        format={dateFormat}
                        onChange={this.handleOnDateRangeChange}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col span={24}>
              <Row type="flex" justify="space-around">
                <Col>
                  <Form.Item label={intl.formatMessage({ id: "email" })}>
                    <Select
                      mode="multiple"
                      placeholder={intl.formatMessage({ id: "select" })}
                      onChange={this.handleOnChangeEmail}
                      style={{ width: "230px" }}
                    >
                      {options}
                    </Select>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item label={intl.formatMessage({ id: "users" })}>
                    <Select
                      mode="multiple"
                      placeholder={intl.formatMessage({ id: "select" })}
                      onChange={this.handleOnChangeUserName}
                      style={{ width: "230px" }}
                    >
                      {optionsUser}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <div style={{ marginTop: "40px" }}>
            <div className="title-bar">
              <ul>
                <div
                  className="cHeaderContainer"
                  style={{ marginRight: "8px" }}
                >
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "sort_assets" })}
                  >
                    <li>
                      <img alt="asset" src="/images/icons/order-icon.svg" />
                      <ul>
                        <li
                          className={orderBy === "createdAt" ? "active" : ""}
                          style={{
                            backgroundColor: colorCreationdate,
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.handleOrderBy("createdAt", "asc");
                          }}
                        >
                          <span
                            key="3"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            {intl.formatMessage({ id: "current_date" })}{" "}
                            <Icon type="arrow-up" />
                          </span>
                          {iconCreationdate && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={orderBy === "-createdAt" ? "active" : ""}
                          style={{
                            backgroundColor: colorCreatedAt,
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.handleOrderBy("createdAt", "desc");
                            //this.handleActive('-createdAt')
                          }}
                        >
                          <span
                            key="1"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            {intl.formatMessage({ id: "current_date" })}{" "}
                            <Icon type="arrow-down" />
                          </span>
                          {iconCreatedAt && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={orderBy === "name" ? "active" : ""}
                          style={{
                            backgroundColor: colorAZ,
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.handleOrderBy("name", "asc");
                            //this.handleActive('name')
                          }}
                        >
                          <span
                            key="4"
                            title="name"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            A - Z
                          </span>
                          {iconAZ && (
                            <Icon
                              type="check"
                              style={{ marginLeft: "120px" }}
                            />
                          )}
                        </li>
                        <li
                          className={orderBy === "-name" ? "active" : ""}
                          style={{
                            backgroundColor: colorZA,
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.handleOrderBy("name", "desc");
                            //this.handleActive('-name')
                          }}
                        >
                          <span
                            key="5"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            Z - A
                          </span>
                          {iconZA && (
                            <Icon
                              type="check"
                              style={{ marginLeft: "120px" }}
                            />
                          )}
                        </li>
                      </ul>
                    </li>
                  </Tooltip>
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "items_per_page" })}
                  >
                    <li>
                      <Icon
                        type="more"
                        style={{
                          color: "white",
                          fontSize: "20px",
                          marginTop: "2px",
                          display: "inline-block",
                          width: "100%"
                        }}
                      />
                      <ul style={{ width: "100px", marginLeft: "100px" }}>
                        <li
                          className={limit === 10 ? "active" : ""}
                          style={{
                            backgroundColor: this.state.paginationColor[10],
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.handlePaginationNumber(10);
                            this.handleActive();
                          }}
                        >
                          <span
                            key="1"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            10
                          </span>
                          {iconPaginationColor[10] && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={limit === 20 ? "active" : ""}
                          style={{
                            backgroundColor: this.state.paginationColor[20],
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.handlePaginationNumber(20);
                            this.handleActive();
                          }}
                        >
                          <span
                            key="1"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            20
                          </span>
                          {iconPaginationColor[20] && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={limit === 40 ? "active" : ""}
                          style={{
                            backgroundColor: this.state.paginationColor[40],
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.handlePaginationNumber(40);
                            this.handleActive();
                          }}
                        >
                          <span
                            key="2"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            40
                          </span>
                          {iconPaginationColor[40] && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={limit === 60 ? "active" : ""}
                          style={{
                            backgroundColor: this.state.paginationColor[60],
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.handlePaginationNumber(60);
                            this.handleActive();
                          }}
                        >
                          <span
                            key="3"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            60
                          </span>
                          {iconPaginationColor[60] && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={limit === 80 ? "active" : ""}
                          style={{
                            backgroundColor: this.state.paginationColor[80],
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.handlePaginationNumber(80);
                            this.handleActive();
                          }}
                        >
                          <span
                            key="4"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            80
                          </span>
                          {iconPaginationColor[80] && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={limit === 100 ? "active" : ""}
                          style={{
                            backgroundColor: this.state.paginationColor[100],
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.handlePaginationNumber(100);
                            this.handleActive();
                          }}
                        >
                          <span
                            key="5"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            100
                          </span>
                          {iconPaginationColor[100] && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                      </ul>
                    </li>
                  </Tooltip>
                  <li style={{ backgroundColor: "transparent" }}>&nbsp;</li>
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "download_asset" })}
                  >
                    <li
                      style={{
                        backgroundColor: "transparent",
                        cursor: "pointer"
                      }}
                      onClick={this.handleExportToFile}
                    >
                      <img
                        alt="asset"
                        src="/images/icons/download_comment.png"
                      />
                    </li>
                  </Tooltip>
                </div>
              </ul>
            </div>
            <div style={{ clear: "both" }}></div>
          </div>
          <div>
            <div className="table-responsive">
              <Table
                rowKey="_id"
                loading={isFetching}
                bordered
                columns={this.columns}
                expandedRowRender={row => (
                  <div>
                    <p>Request</p>{" "}
                    <ReactJson
                      collapsed={true}
                      iconStyle="circle"
                      src={JSON.parse(row.requestBody)}
                      theme="monokai"
                    />
                    <p>Response</p>{" "}
                    <ReactJson
                      collapsed={true}
                      iconStyle="circle"
                      src={JSON.parse(row.responseBody)}
                      theme="monokai"
                    />
                  </div>
                )}
                dataSource={data}
                pagination={{
                  current: page,
                  pageSize: limit,
                  total: count,
                  onChange: this.handleOnPageChange
                }}
              />
            </div>
          </div>
        </div>
        <Col span={24}>
          <Form layout="vertical" onSubmit={this.handleSubmit}>
            <Row gutter={60} type="flex" justify="center">
              {this.functionalServices().map(e => (
                <Col md={6} key={e._id}>
                  <Button
                    type={filter.modules[e.key_name] ? "primary" : "default"}
                    block
                    onClick={() => this.handleModuleFilter(e.key_name)}
                  >
                    {e.product}
                  </Button>
                </Col>
              ))}
            </Row>
          </Form>
        </Col>
        <ClientRegister
          stateFromActivity={this.state}
          searchClient={this.state.searchInClient}
        ></ClientRegister>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    isFetchingSauronReport: state.client.isFetchingSauronReport,
    // users: state.users.allUsers,
    users: state.users.data,
    planServices: state.planServices.data,
    cpActivityLogSelectedValue: state.app.cpActivityLogSelectedValue
  };
};

const mapDispatchToProps = {
  handleFetchingSauronReport,
  setCpActivityLogSelectedValue
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivityRegister))
);
